export class Widget {
  constructor(private id: number, private label: string, private type: number, private favicon: String,
              private htmlTemplate: String, private insertables: Array<any>) { }

  getHtml() {
    let html = this.htmlTemplate;

    for (let i = 0; i < this.insertables.length; i++) {
      const selector = '{{' + this.insertables[i].selector + '}}';
      const val = this.insertables[i].value;

      html = html.replace(selector, val);
    }

    return html;
  }

  getLabel(){
    return this.label;
  }

  getType(){
    return this.type;
  }

  getFavicon(){
    return this.favicon;
  }

  getID() {
    return this.id;
  }

  getHtmlTemplate() {
    return this.htmlTemplate;
  }

  getInsertables() {
    return this.insertables;
  }
}
